<template>
  <v-card
    flat
    tile
    class="mx-auto"
  >
    <v-app-bar
      class="navbar"
      flat
      dark
      fixed
      height="50"
      color="rgba(0,0,0,0)"
    >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

      <v-toolbar-title>SHORT-STORIES</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        href="https://willard.network/"
        class="d-none d-sm-flex"
        depressed
        text
      >
        Main
      </v-btn>
      <v-btn
        @click="$vuetify.goTo('#gonedark', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        Events
      </v-btn>
      <v-divider vertical></v-divider>
      <v-btn
        @click="$vuetify.goTo('#experience', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        What Are Short Stories?
      </v-btn>
      <v-btn
        @click="$vuetify.goTo('#destiny', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        Concept Submissions
      </v-btn>
      <!--
      <v-btn
        @click="$vuetify.goTo('#lore', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        Lore
      </v-btn>
      -->
      <v-btn
        @click="$vuetify.goTo('#seas', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        Settings
      </v-btn>
      <v-btn
        @click="$vuetify.goTo('#team', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        The Team
      </v-btn>
      <v-divider vertical></v-divider>
      <v-btn
        href="https://willard.network/forums/wn/short-stories-forum.115/"
        class="d-none d-sm-flex"
        depressed
        text
      >
        Forums
      </v-btn>
      <v-btn
        @click="$vuetify.goTo('#faq', options)"
        class="d-none d-sm-flex"
        depressed
        text
      >
        FAQ
      </v-btn>
      <v-divider vertical></v-divider>
      <v-btn
        href="https://discord.gg/Zu2ggkDzUA"
        target="_blank"
        class="d-none d-sm-flex"
        depressed
        icon
      >
        <v-icon>mdi-microphone-message</v-icon>
      </v-btn>
      <v-btn
        href="https://steamcommunity.com/groups/wnshortstories"
        target="_blank"
        class="d-none d-sm-flex"
        depressed
        icon
      >
        <v-icon>mdi-steam</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
    >
      <v-list nav>
        <v-list-item-group class="text-center">
          <v-img
            alt="Short-Stories"
            class="my-4 mx-auto"
            width="68"
            src="assets/img/short_stories_logo.svg"
          ></v-img>
          <v-divider></v-divider>
          <v-list-item
            @click="$vuetify.goTo('#experience', options)"
            class="mb-0"
            tile
          >
            <v-list-item-title class="rounded-0">Experience</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="$vuetify.goTo('#destiny', options)"
            class="mb-0"
            tile
          >
            <v-list-item-title class="rounded-0">Destiny</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <!--
          <v-list-item
            @click="$vuetify.goTo('#lore', options)"
            class="mb-0"
            tile
          >
            <v-list-item-title class="rounded-0">Lore</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
        -->
          <v-list-item
            @click="$vuetify.goTo('#seas', options)"
            class="mb-0"
            tile
          >
            <v-list-item-title class="rounded-0">Seasons</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="$vuetify.goTo('#team', options)"
            class="mb-0"
            tile
          >
            <v-list-item-title class="rounded-0">The Team</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="$vuetify.goTo('#faq', options)"
            class="mb-0"
            tile
          >
            <v-list-item-title class="rounded-0">FAQ</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <div class="d-flex justify-center mt-8">
            <v-btn
              href="https://willard.network/forums/wn/short-stories-forum.115/"
              target="_blank"
              class="mx-1"
              depressed
              icon
            >
              <v-icon>mdi-forum</v-icon>
            </v-btn>
            <v-btn
              href="https://discord.gg/Zu2ggkDzUA"
              target="_blank"
              class="mx-1"
              depressed
              icon
            >
              <v-icon>mdi-text-to-speech</v-icon>
            </v-btn>
            <v-btn
              href="https://steamcommunity.com/groups/wnshortstories"
              target="_blank"
              class="mx-1"
              depressed
              icon
            >
              <v-icon>mdi-steam</v-icon>
            </v-btn>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-container
      fluid
      class="pa-0"
    >
      <Intro />
      <Experience />
      <Destiny />
      <!--<Lore />-->
      <Seas />
      <Team />
      <Faq />
      <Join />
      <GoneDark />
    </v-container>
  </v-card>
</template>

<script>
import * as easings from 'vuetify/es5/services/goto/easing-patterns'
import Intro from '@/views/Intro.vue'
import Experience from '@/views/Experience.vue'
import Destiny from '@/views/Destiny.vue'
//import Lore from '@/views/Lore.vue'
import Team from '@/views/Team.vue'
import Seas from '@/views/Seas.vue'
import Faq from '@/views/Faq.vue'
import Join from '@/views/Join.vue'
import GoneDark from '@/views/GoneDark.vue'
export default {
  name: 'Home',
  data: () => ({
    drawer: false,
    duration: 400,
    offset: 0,
    easing: 'easeInOutCubic',
    easings: Object.keys(easings)
  }),
  components: {
    Intro,
    Experience,
    Destiny,
 //   Lore,
    Team,
    Seas,
    Faq,
    Join,
    GoneDark
  },
  computed: {
    options () {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      }
    }
  }
}
</script>
<style lang="scss">
html,
body {
  background-color: #1c1c1c;
}
@media (max-width: 450px) {
  .navbar {
    background-color: rgba(0, 0, 0, 0.9) !important;
  }
}
.theme--dark.v-navigation-drawer {
  background-color: rgba(54, 54, 54, 0.5) !important;
  backdrop-filter: blur(4px) !important;
}
</style>
